<template>

</template>

<script>
export default {
  name: "SiteNotify"
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/contents/main/interest/SiteNotify.vue